import { Banner, Indicator } from '@nexelem/components';
import { PropsWithChildren, useState } from 'react';
import { useCustomTranslation } from '../../../../hooks';

type SearchResultsListProps = {
  count: number;
  bannerMessage: string;
};

export const SearchResultsList = ({ count, bannerMessage, children }: PropsWithChildren<SearchResultsListProps>) => {
  const { tWrapper } = useCustomTranslation('common');
  const [isDismissed, setIsDismissed] = useState(false);

  return (
    <div className="flex h-full flex-col">
      <div className="px-6">
        <div className="mb-2 flex items-center gap-2 text-t16-b">
          <span>{tWrapper('searchResults')}</span> <Indicator count={count} />
        </div>
        {!isDismissed && (
          <Banner
            withCloseButton
            className="mb-2"
            emphasis="strong"
            message={bannerMessage}
            type="info"
            onClose={() => setIsDismissed(true)}
          />
        )}
        {count === 0 && <div className="mt-4 text-center text-s16-sb">{tWrapper('noResultsFound')}</div>}
      </div>
      <div className="flex-1 overflow-auto">{children}</div>
    </div>
  );
};
